
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { AssetsTableProps, ServiceLine } from "../../StarlinkReports/types";
import { Avatar, Grid, IconButton, Paper, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import React from 'react';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import CircleIcon from '@mui/icons-material/Circle';
import OptedIn from "../../../asset/image/opted_in.svg"
import OptedOut from "../../../asset/image/opted_out.svg"
import moment from "moment";
import { useEffect, useState } from "react";
import _ from "lodash";
import SortArrows from "../../SortArrows";
import EditNotificationsIcon from '@mui/icons-material/EditNotifications';
import { convertDateTimeIntoTimezone, getDecodeURI, getEncodedURI, middleEllipsis, useAuthorization } from "../../../utils/util";
import { DEFAULT_DATE_FORMAT } from "../../../utils/constants";
import { getQuotaAvailablityAlert } from "../../StarlinkReports/slice";

const AssetsTable = (props: AssetsTableProps) => {
    const { authReducer, tableData, sortOrder, sortBy, onChangeSorting, onEditServiceLineQuota, onEditServiceLineAvailability, isReadOnlyUser, getQuotaAvailablityAlert, quotaAvailablityAlerts, location, history, expand } = props;

    const [currentAsset, setCurrentAsset] = useState({ asset_display_name: '', asset_number: '', action: '' });
    const [switchServiceLineToggle, setSwitchServiceLineToggle] = useState(false)
    const { isAdmin } = useAuthorization();

    useEffect(() => {
        if (!_.isEmpty(currentAsset) && !_.isEmpty(quotaAvailablityAlerts) && quotaAvailablityAlerts.length > 0 && quotaAvailablityAlerts[0]?.quota_alert && currentAsset.action === 'quota') {
            let _serviceLine: ServiceLine = {
                serviceLineNumber: currentAsset.asset_number,
                nickname: currentAsset.asset_display_name || '',
                quotaAlert: quotaAvailablityAlerts[0].quota_alert || {
                    serviceLineNumber: currentAsset.asset_number,
                    alertingThresholds: [],
                    notificationMethods: [],
                    usersToNotify: []
                },
            }
            onEditServiceLineQuota(_serviceLine);
        }

        if (!_.isEmpty(currentAsset) && !_.isEmpty(quotaAvailablityAlerts) && quotaAvailablityAlerts.length > 0 && quotaAvailablityAlerts[0]?.availability_alert && currentAsset.action === 'availablity') {

            let _serviceLine: ServiceLine = {
                serviceLineNumber: currentAsset.asset_number,
                nickname: currentAsset.asset_display_name || '',
                availabilityAlert: quotaAvailablityAlerts[0].availability_alert || {
                    serviceLineNumber: currentAsset.asset_number,
                    alertingThreshold: "15m",
                    notificationMethods: [],
                    usersToNotify: []
                },
            }
            onEditServiceLineAvailability(_serviceLine);
        }
    }, [quotaAvailablityAlerts])

    const LetterCircle = ({ letter, bgColor, color }: { letter: string, bgColor: string, color: string }) => (
        <Avatar sx={{ backgroundColor: bgColor, color, width: 20, height: 20 }}>
            <Typography style={{ color: color }} fontSize={"10px"} >{letter}</Typography>
        </Avatar>
    );


    const IconCircle = ({ icon, bgColor }: { icon: React.ReactNode, bgColor: string }) => (
        <Avatar sx={{ backgroundColor: bgColor, width: 20, height: 20 }}>
            {icon}
        </Avatar>
    );

    const handleClickSelect = (column: string, value: string | { dpName: string, dpId: string }) => {
        const params: any = getDecodeURI(location.search);
        if (column === 'serviceLine') {
            params.serviceLineAccess = value;
        } else if (typeof value === 'object') {
            params.ouName = value.dpName;
            params.ouId = value.dpId;
        }
        history.push({ pathname: location.pathname, search: `?${getEncodedURI(params)}` });
    };

    const getKitSerialNumbers = (userTerminals = '') => {
  try {
    const parsed = JSON.parse(userTerminals);
    if (!Array.isArray(parsed)) return 'N/A';
    const kits = parsed.map(item => item?.kitSerialNumber).filter(Boolean);
    return kits.length > 1 ? kits.join(', ') : kits[0] || 'N/A';
  } catch {
    return 'N/A';
  }
};


    return (
        <TableContainer component={Paper} className="starlink--table_container" style={{ maxHeight: expand.isCardExpanded ? 'calc(100vh - 405px)' : 'calc(100vh - 335px)' , overflow: 'auto' }}>
            <Table sx={{ minWidth: 650 }} size="small" aria-label="starlink--usage" stickyHeader style={{ tableLayout: 'fixed' }}>
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <SortArrows sortBy={sortBy} sortOrder={sortOrder} field={'asset_display_name'} onChange={onChangeSorting}>
                                <div className="starlink-service-line-toggle">
                                    <span className="font-wt-900">SERVICE LINE</span>
                                    <div
                                        onClick={(e) => e.stopPropagation()}
                                        onMouseDown={(e) => e.stopPropagation()} >
                                        <Tooltip title="SL Name / SL Number">
                                            <Switch size="small"
                                                checked={switchServiceLineToggle}
                                                onChange={(e) => { e.stopPropagation(); setSwitchServiceLineToggle(!switchServiceLineToggle) }}
                                                inputProps={{ 'aria-label': 'controlled' }}
                                            />
                                        </Tooltip>
                                    </div>
                                </div>
                            </SortArrows>
                        </TableCell>
                        <TableCell >
                            <span className="font-wt-900">STATUS</span>
                        </TableCell>
                        <TableCell>
                            <SortArrows sortBy={sortBy} sortOrder={sortOrder} field={'account_dp_name'} onChange={onChangeSorting}>
                                <span className="font-wt-900">ORGANIZATION</span>
                            </SortArrows>
                        </TableCell>
                        <TableCell>
                            <SortArrows sortBy={sortBy} sortOrder={sortOrder} field={'dp_name'} onChange={onChangeSorting}>
                                <span className="font-wt-900">SUB ORGANIZATION</span>
                            </SortArrows>
                        </TableCell>
                        <TableCell>
                            <SortArrows sortBy={sortBy} sortOrder={sortOrder} field={'subscription_line_description'} onChange={onChangeSorting}>
                                <span className="font-wt-900"> PLAN</span>
                            </SortArrows>
                        </TableCell>
                        <TableCell>
                            <SortArrows sortBy={sortBy} sortOrder={sortOrder} field={'billing_usage_percent'} onChange={onChangeSorting}>
                                <span className="font-wt-900">BILLING USAGE</span>
                            </SortArrows>
                        </TableCell>
                        <TableCell>
                            <SortArrows sortBy={sortBy} sortOrder={sortOrder} field={'billing_day_of_month'} onChange={onChangeSorting}>
                                <span className="font-wt-900">BILLING DATE</span>
                            </SortArrows>
                        </TableCell>
                        <TableCell width={'5%'}>
                            <SortArrows sortBy={sortBy} sortOrder={sortOrder} field={'k4_site_name'} onChange={onChangeSorting}>
                                <span className="font-wt-900">SITE</span>
                            </SortArrows>
                        </TableCell>
                        <TableCell width={'5%'}>ACTIONS</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        tableData?.length > 0 ? tableData?.map((asset) => (
                            <TableRow key={asset.user_terminal_id}>
                                <TableCell >
                                    <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Tooltip classes={{ tooltip: 'starlink--tooltip' }} title={
                                            <Grid>
                                                <Table size="small" className="starlink--tooltip">
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell classes={{ root: 'starlink--tooltip--value_title' }}>
                                                                Service Line Number
                                                            </TableCell>
                                                            <TableCell>
                                                                {asset.asset_number}
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell classes={{ root: 'starlink--tooltip--value_title' }}>
                                                                Account Number
                                                            </TableCell>
                                                            <TableCell>
                                                                {asset.account_number}
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell classes={{ root: 'starlink--tooltip--value_title' }}>
                                                                Account Name
                                                            </TableCell>
                                                            <TableCell>
                                                                {asset.account_name}
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell classes={{ root: 'starlink--tooltip--value_title' }}>
                                                                KIT Number
                                                            </TableCell>
                                                            <TableCell>
                                                                   {getKitSerialNumbers(asset?.user_terminals)}
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell classes={{ root: 'starlink--tooltip--value_title' }}>
                                                                Custom Plan
                                                            </TableCell>
                                                            <TableCell>
                                                                {asset?.is_custom_plan === true ? 'Yes' : 'No'}
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell classes={{ root: 'starlink--tooltip--value_title' }}>
                                                                Mobile Priority
                                                            </TableCell>
                                                            <TableCell>
                                                                {asset?.opted_in !== "" ? 'Enabled' : 'Disabled'}
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell classes={{ root: 'starlink--tooltip--value_title' }}>
                                                                Subscription Status
                                                            </TableCell>
                                                            <TableCell>
                                                                {asset?.is_service_line_paused === false ? 'Active' : 'Inactive'}
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </Grid>
                                        }>
                                            <span>
                                            {switchServiceLineToggle ? asset?.asset_number :  asset.asset_display_name ? middleEllipsis(asset.asset_display_name) : asset.account_name ? asset.account_name : asset.asset_number}
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                </TableCell>
                                <TableCell >
                                     <div className="starlink-usage-icon-gap">
                                    <Tooltip
                                        title={`Subscription Status: ${asset?.is_service_line_paused === false ? "Active" : "Inactive"}`}
                                        arrow
                                    >
                                        <CircleIcon
                                            id={asset?.is_service_line_paused === false ? "greenDotSymbol" : "greyDotSymbol"}
                                        />
                                    </Tooltip>

                                    <Tooltip
                                        title={`Mobile Priority: ${asset?.opted_in ? "Enabled" : "Disabled"}`}
                                        arrow
                                    >
                                        <img
                                            src={asset?.opted_in ? OptedIn : OptedOut}
                                            width="18"
                                            height="18"
                                            alt=""
                                        />
                                    </Tooltip>
                                </div>

                                </TableCell>
                                <TableCell id="selectedClick-column" onClick={() => { if(isAdmin) { handleClickSelect('org', { dpName: asset.account_dp_name, dpId: asset.account_dp_id })}}}>
                                    {asset.account_dp_name}
                                </TableCell>
                                <TableCell id="selectedClick-column" onClick={() => { if(isAdmin) { handleClickSelect('org', { dpName: asset.dp_name, dpId: asset.dp_id })}}}>
                                    {asset.dp_name}
                                </TableCell>
                                <TableCell>{asset?.subscription_line_description}</TableCell>
                                <TableCell>
                                    
                                        <Tooltip classes={{ tooltip: 'starlink--tooltip' }} title={
                                            <Grid>
                                                <Table size="small">
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell classes={{ root: 'starlink--tooltip--value_title' }}>{'Global Priority GB'}</TableCell>
                                                            <TableCell>{asset?.global_priority || 0}  GB</TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell classes={{ root: 'starlink--tooltip--value_title' }}>{'Local Priority GB'}</TableCell>
                                                            <TableCell>{asset?.local_priority || 0}  GB</TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell classes={{ root: 'starlink--tooltip--value_title' }}>{'Mobile GB'}</TableCell>
                                                            <TableCell>{asset?.mobile_priority_data || 0}  GB</TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell classes={{ root: 'starlink--tooltip--value_title' }}>{'Other Data GB'}</TableCell>
                                                            <TableCell>{asset?.other_data || 0}  GB</TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell classes={{ root: 'starlink--tooltip--value_title' }}>{'Legacy Data GB'}</TableCell>
                                                            <TableCell>{asset?.legacy_plans_data || 0}  GB</TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </Grid>
                                        }>
                                        <div style={{color: Number(asset?.billing_usage_percent) >= 100 ? "red" : ""}}>{Number(asset?.curr_billing_usage_gbb)?.toFixed(2)} GB ({parseFloat(asset?.billing_usage_percent).toFixed(2)}%)</div>
                                        </Tooltip> 
                                 </TableCell>
                                <TableCell>
                                    {asset?.current_billing_start_date ? convertDateTimeIntoTimezone(moment(asset.current_billing_start_date).add(1, 'months').toString(), authReducer.userTimezone, DEFAULT_DATE_FORMAT) : ''}
                                </TableCell>
                                <TableCell>
                                    {asset?.k4_site_name}
                                </TableCell>
                                <TableCell>
                                    <Grid classes={{ root: 'starlink--base--flex--align--center starlink--base--flex--justify--center' }}>

                                        {!isReadOnlyUser && <Tooltip title="Set/Edit Availability Alert">
                                                <IconButton size="small" onClick={async () => {
                                                    let quotaAlert = await getQuotaAvailablityAlert({ serviceLineNumber: [asset.asset_number] })
                                                    setCurrentAsset({
                                                        asset_number: asset.asset_number,
                                                        asset_display_name: asset.asset_display_name,
                                                        action: "availablity"
                                                    })
                                                }}>
                                                    <EditNotificationsIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        }
                                    </Grid>
                                </TableCell>
                            </TableRow>
                        )) : <TableRow>
                            <TableCell colSpan={9} align='center'>
                                No data available
                            </TableCell>
                        </TableRow>
                    }
                </TableBody>
            </Table>
        </TableContainer>
    )
}

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    assetUsageSeries: state.starlinkReports.assetUsage,
    quotaAvailablityAlerts: state.starlinkReports.quotaAvailablityAlerts,
    isReadOnlyUser: state?.authReducer?.isReadOnlyUser
});

export default withRouter(
    connect(mapStateToProps, {
        getQuotaAvailablityAlert
    })(AssetsTable)
);